export default __webpack_public_path__ + "static/media/loading.30795e8a.gif";